<template>
	<div class="master-container">
		<div class="box mainCont">
			<div class="item">
				<div class="label">
					<span>服务分类</span><i class="iconfont icon-right"></i>
				</div>
				<div class="classList">
					<span class="c_item" :class="productTypeId==''?'active':''" @click="getErList()">全部</span>
					<span class="c_item" :class="productTypeId==item.id?'active':''" v-for="(item,index) in listType" :key="index" @click="getErList(item)">{{item.typeName}}</span>
				</div>
			</div>
			<div class="item" v-if="listType2.length">
				<div class="label">
					<span>二级分类</span><i class="iconfont icon-right"></i>
				</div>
				<div class="classList">
					<span class="c_item" :class="productTypeId2==''?'active':''" @click="getErBtn()">全部</span>
					<span class="c_item" :class="productTypeId2==item.id?'active':''" @click="getErBtn(item)" v-for="(item,index) in listType2" :key="index">{{item.typeName}}</span>
				</div>
			</div>
			<div class="item" v-if="areaArr.length">
				<div class="label">
					<span>师傅区域</span><i class="iconfont icon-right"></i>
				</div>
				<div class="classList">
					<span class="c_item" :class="area==''?'active':''" @click="getAreaBtn()">全部</span>
					<span class="c_item" :class="area==item.typeName?'active':''" @click="getAreaBtn(item)" v-for="(item,index) in areaArr" :key="index">{{item.typeName}}</span>
				</div>
			</div>
		</div>
		<div class="masterCont mainCont">
			<div class="l_list">


				
				<div class="list"  >
					<div   class="item"  v-for="(item,index) in list" :key="index"  @click="item.sfrzStatus === '1' ? goDetail(item) : null">
						<div class="img"><img :src="item.headImg||'../../../static/master.png'" alt="1"></div>
						<div class="txt">
							<div class="name">
								<h5>{{item.name||'--'}}</h5>
								<p class="type" v-if="item.sfrzStatus==='1'">已实名</p>
								<p class="type2" v-if="item.sfrzStatus!=='1'">未实名</p>
							</div>
							<div class="t_foot">
								<div class="xing"><i class="iconfont icon-lujing"></i><span>{{item.pjfs||'0.0'}}</span></div>
								<span>已服务{{item.fwNum||0}}人</span>
							</div>
							<div class="tips" v-if="item.sclyArr">
								<span class="s_tip" v-if="i<3" v-for="(itemIn,i) in item.sclyArr" :key="i">{{itemIn}}</span>
							</div>
						</div>
					</div>
				</div>
                <!-- <div class="list"  >
					<div   class="item" v-if="item.sfrzStatus!=='1'" v-for="(item,index) in list" :key="index" >
						<div class="img"><img :src="item.headImg||'../../../static/master.png'" alt="1"></div>
						<div class="txt">
							<div class="name">
								<h5>{{item.name||'--'}}</h5>
								<p class="type" v-if="item.sfrzStatus==='1'">已实名</p>
								<p class="type2" v-if="item.sfrzStatus!=='1'">未实名</p>
							</div>
							<div class="t_foot">
								<div class="xing"><i class="iconfont icon-lujing"></i><span>{{item.pjfs||'0.0'}}</span></div>
								<span>已服务{{item.fwNum||0}}人</span>
							</div>
							<div class="tips" v-if="item.sclyArr">
								<span class="s_tip" v-if="i<3" v-for="(itemIn,i) in item.sclyArr" :key="i">{{itemIn}}</span>
							</div>
						</div>
					</div>
				</div> -->



				<div class="pageBox">
					<el-empty v-if="!loading&&list.length==0" description="暂无师傅"></el-empty>
				</div>
				<div class="pageBox">
					<el-pagination background layout="prev, pager, next" :page-size="pageSize" :hide-on-single-page="true" :total="total" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
			<div class="r_active">
				<div class="inBox1" v-for="(item,index) in dtList" :key="index" v-if="index==0">
					<h3 class="in_tit">师傅动态</h3>
					<div class="inInfo" >
						<img :src="item.headImg" class="img" alt="">
						<div class="txt">
							<h5>{{item.memberName}}</h5>
							<p>{{item.createTime}}</p>
						</div>
					</div>
					<p class="p">{{item.title}}</p>
					<div class="imgs" v-if="item.img">
						<div class="img" v-for="(itemIn,i) in item.imgArr" >
							<el-image  :key="i" 
								style="width: 97px;height: 97px;border-radius: 8px;"
								:src="itemIn" 
								:preview-src-list="item.imgArr">
							</el-image>
						</div>
					</div>
					<div class="videoB" v-if="item.video">
						<video controls  :src="item.video"></video>
					</div>
					<div class="seeBox">
						<span>浏览{{item.lookNum||0}}</span>
						<div class="see_i">
							<i class="iconfont icon-stick col"  v-if="item.sfdz=='1'"></i>
							<i class="iconfont icon-dianzan" v-else></i>
							<span>{{item.dzNum||0}}</span>
						</div>
					</div>
				</div>
				<div class="inBox1" v-for="(item,index) in dtList" :key="index" v-if="index==1">
					<div class="inInfo">
						<img :src="item.headImg" class="img" alt="">
						<div class="txt">
							<h5>{{item.memberName}}</h5>
							<p>{{item.createTime}}</p>
						</div>
					</div>
					<p class="p">{{item.title}}</p>
					<div class="imgs" v-if="item.img">
						<!-- <img v-for="(itemIn,i) in item.imgArr" :key="i"  :src="itemIn" alt=""> -->
						<div class="img" v-for="(itemIn,i) in item.imgArr" >
							<el-image  :key="i" 
								style="width: 97px;height: 97px;border-radius: 8px;"
								:src="itemIn" 
								:preview-src-list="item.imgArr">
							</el-image>
						</div>
						
					</div>
					<div class="videoB" v-if="item.video">
						<video controls  :src="item.video"></video>
					</div>
					<div class="seeBox">
						<span>浏览{{item.lookNum||0}}</span>
						<div class="see_i">
							<i class="iconfont icon-stick col"  v-if="item.sfdz=='1'"></i>
							<i class="iconfont icon-dianzan" v-else></i>
							<span>{{item.dzNum||0}}</span>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
	import {getShifuMemberList,getProductTypeList,getDongtaiList,getChildAreaList} from '@/api/api'
	
import { EventBus,globalVar } from '@/utils/event-bus.js';
export default {
	name: 'master',
	data() {
		return {
			city:'',
			key:'',//搜索值
			listType:[],//一级分类
			listType2:[],//二级分类
			list:[],
			productTypeId:'',//一级Id
			productTypeId2:'',//二级Id
			areaArr:[],//师傅区域
			area:'',
			// areaIndex
			pageIndex:1,
			pageSize:16,
			total:0,
			loading:true,
			dtList:[],//动态
			currentGlobalVar: globalVar // 初始化为当前的全局变量值
		};
	},
	created() {
		EventBus.$on('globalVarChanged', (newValue) => {
			  console.log("89899898xxxxx"); 
               console.log(globalVar); // 输出 'Hello'
			    console.log("89899xxxxx898xxxxx"); 
             this.currentGlobalVar = newValue; // 更新当前组件的值
             
			 this.city = this.currentGlobalVar;
			  this.city = this.$store.state.globalVar; 
			    this.city= globalVar
				 console.log("89899xxxxx898xxxxx999999"); 
					    console.log(this.city); 
						 console.log("89899xxxxx898xxxxx9999999999"); 
			this.getChildAreaList();
		});
	},
	// beforeDestroy() {
	// 	EventBus.$off('globalVarChanged');
	// },
	mounted() {

    // 组件挂载后执行的代码
        console.log('Component mounted');
		console.log(this.$store.state.globalVar);

    // 在挂载时检查 globalVar 是否为空
    if (this.$store.state.globalVar) {
        this.city = this.$store.state.globalVar; // 只有当 globalVar 不为空时才赋值
    } else {
        console.log('globalVar is empty, not assigning to city');
    }

	
		console.log(this.$route.path);
		console.log(this.city);
        // 这里可以放置初始化代码
        if (this.$route.path === '/master') {
			//  console.log("89899898777777777777"); 
            //   console.log(this.$store.state.globalVar); 
			//   this.city = this.$store.state.globalVar; 
            // console.log('Mounted on /master');
			//        console.log(this.city); // 输出 'Hello'
			   console.log("89899xxxxx8");
	EventBus.$on('globalVarChanged', (newValue) => {
			  console.log("89899898xxxxx99999999999999999999999999999999"); 
               console.log(globalVar); // 输出 'Hello'
			    console.log("89899xxxxx898xxxxx"); 
             this.currentGlobalVar = newValue; // 更新当前组件的值
             
			 this.city = this.currentGlobalVar;
			  this.city = this.$store.state.globalVar; 
			    this.city= globalVar
				 console.log("89899xxxxx898xxxxx999999"); 
					    console.log(this.city); 
						 console.log("89899xxxxx898xxxxx9999999999"); 

							this.getList(); 
			this.getChildAreaList();
				this.getProductTypeList();
		//this.getList();
		this.getDongtaiList();
		});
         


            // 这里放置你需要执行的代码
        }


		this.getProductTypeList();

  if (this.$store.state.globalVar) {
    this.getList();
    } else {
        console.log('globalVar is empty, not assigning to city');
    }

		
		this.getDongtaiList();
		this.getChildAreaList();
	},
	methods: {
		// 一级分类
		getProductTypeList(){
			getProductTypeList({flType: "0"}).then(res => {
				this.listType = res.data;
			})
		},
		// 二级分类
		getErList(item){
			if(item){
				this.productTypeId = item.id;
				this.productTypeId2 = '';
				getProductTypeList({flType: "0",parentId:item.id}).then(res => {
					this.listType2 = res.data;
					this.pageIndex = 1;
					this.getList();
				})
			}else{
				this.productTypeId = '';
				this.productTypeId2 = '';
				this.pageIndex = 1;
				this.getList();
			}
			
		},
		// 二级--点击
		getErBtn(item){
			if(item){
				this.productTypeId2 = item.id;
				this.pageIndex = 1;
				this.getList();
			}else{
				this.productTypeId2 = '';
				this.pageIndex = 1;
				this.getList();
			}
		},
		// 获取区域
		getChildAreaList(){
			getChildAreaList({name:this.city||globalVar}).then(res => {
				console.log(res)
				this.areaArr = res.data;
			})
		},
		// 师傅区域--点击
		getAreaBtn(item){
			if(item){
				this.area = item.typeName
			}else{
				this.area = '';
			}
			this.pageIndex = 1;
			this.getList();
		},
		getList(){
			console.log("8888888884iop444444656666666666")
			console.log(this.city)
			console.log("88888888822iop222488888888888888888")
			this.loading = true;
			let pageIndex = this.pageIndex;
			let productTypeId = this.productTypeId2?this.productTypeId2:this.productTypeId;
			let formObj = {pageIndex,pageSize:this.pageSize,key:this.key,type:productTypeId};
			let area = '';
			if(this.area){
				formObj.area = this.area;
			}else{
				formObj.city = this.city;
			}
			getShifuMemberList(formObj).then(res => {
				let list = res.data;
				list.forEach(ele=>{
					if(ele.sclyInfo){
						ele.sclyArr = ele.sclyInfo.split(',')
					}
				})
				this.total = res.total;
				this.list = list;
				this.loading = false;
			})
		},
		// 分页
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getList();
		},
		// 动态
		getDongtaiList(){
			getDongtaiList({pageIndex:1,pageSize:2,}).then(res => {
				let list = res.data;
				list.forEach(ele=>{
					if(ele.img){
						ele.imgArr = ele.img.split(',')
					}
				})
				this.dtList = list;
			})
		},
		goDetail(item){
			this.$router.push({
			path: '/master/detail',
				query: {
					id: item.id
				}
			})
		},
	},
};
</script>
<style lang="scss">
.master-container{background-color: #F5F8F9;padding-top:24px;
	.box{background: #FFFFFF;border-radius: 8px;padding: 24px 24px 0;
		.item{display: flex;align-items: flex-start;
			.label{display: flex;align-items: center;justify-content: space-between;width: 92px;flex: 0 0 92px;line-height: 28px;
				color: #1F263F;font-size: 16px;
				i{color: #A4A9B7;font-size: 12px;}
			}
			.classList{display: flex;align-items: center;flex-wrap: wrap;margin-right: -26px;margin-left: 16px;
				&.bg{background-color: #F5F8F9;}
				.c_item{padding: 0 8px;line-height: 28px;height: 28px;border-radius: 4px;margin-right: 26px;color: #6B738B;font-size: 16px;margin-bottom: 12px;cursor: pointer;transition: all .3s;
					&.active,&:hover{background: rgba(47,120,255,0.1);color: #2F78FF;}
				}
			}
		}
	}
	.masterCont{display: flex;justify-content: space-between;margin-top: 30px;
		.l_list{position: relative;width: 100%;
			.list{display: flex;flex-wrap: wrap;
				.item{width: 400px;background: #FFFFFF;border-radius: 8px;display: flex;align-items: center;padding: 20px;margin-right: 20px;margin-bottom: 20px;cursor: pointer;
					.img{width: 80px;height: 80px;background: #D9D9D9;border-radius: 50%;
						img{width: 100%;height: 100%;border-radius: 50%;}
					}
					.txt{flex: 1;padding-left:16px;
						.name{display: flex;align-items: center;margin-bottom: 10px;
							h5{color: #1F263F;font-size: 16px;font-weight: bold;}
							.type{width: 42px;height: 18px;line-height: 18px;text-align: center;background: #1C274C;border-radius: 4px;color: #F7C566;font-size: 12px;margin-left: 8px;}
							.type22{width: 42px;height: 18px;line-height: 18px;text-align: center;background: #CCCCCC;border-radius: 4px;color: #FF0000;font-size: 12px;margin-left: 8px;}
							.type2 {
    width: 42px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #E0E0E0; /* 浅灰色背景 */
    border-radius: 4px;
    color: #1C274C; /* 深蓝色字体 */
    font-size: 12px;
    margin-left: 8px;
    font-weight: bold; /* 增加视觉重点 */
}

						}
						
						.tips{display: flex;align-items: center;
							.s_tip{padding: 0 6px;height: 22px;line-height: 22px;background: #F5F8F9;border-radius: 4px;color: #6B738B;font-size: 12px;margin-top: 4px;margin-right: 4px;}
						}
						.t_foot{display: flex;align-items: center;margin-bottom: 8px;
							span{color: #A4A9B7;font-size: 12px;}
							.xing{display: flex;align-items: center;margin-right: 8px;
								color: #F39059;font-size: 14px;
								i{font-size: 12px;}
								span{font-weight: bold;margin-left: 5px;}
							}
						}
					}
				}
			}
		}
		.pageBox{display: flex;align-items: center;justify-content: space-around;margin-bottom: 30px;}
		.r_active{width: 356px;
			.inBox1{width: 356px;background: #FFFFFF;border-radius: 8px;padding: 24px;margin-bottom: 16px;
				.in_tit{color: #1F263F;font-size: 20px;font-weight: bold;margin-bottom: 24px;}
				.inInfo{display: flex;align-items: center;margin-bottom: 16px;
					.img{width: 45px;height: 45px;border-radius: 50%;margin-right: 12px;}
					.txt{
						h5{color: #1F263F;font-size: 16px;margin-bottom: 5px;}
						p{color: #A4A9B7;font-size: 12px;}
					}
				}
				.p{color: #1C274C;line-height: 18px;font-size: 14px;}
				.imgs{margin-top: 8px;display: flex;align-items: center;flex-wrap: wrap;
					.img{width: 97px;height: 97px;border-radius: 8px;margin-right: 8px;margin-top: 8px;
						&:nth-child(3n+3){margin-right: 0;}
					}
				}
				.videoB{margin-top: 16px;
					video{width: 100%;max-height: 200px;}
				}
				.seeBox{display: flex;align-items: center;justify-content: space-between;margin-top: 14px;
					span{color: #A4A9B7;font-size: 12px;}
					.see_i{display: flex;align-items: center;
						i{color: #333;margin-right: 4px;font-size: 14px;
							&.col{color: #2F78FF;}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/master/index.vue